import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import useRoleCheck from "../../hooks/useRoleCheck";
import dashboardIcon from "../../assets/icons/menuIcons/dashboard.svg";
import { useParams } from "react-router-dom";

const MenuItems = ({ tenant, userInfo }) => {
  const { t } = useTranslation();
  const { slug } = useParams();

  // ROLES
  // const isAdmin = useRoleCheck("admin");

  // STATE
  const [isTreatmentPlansEnabled, setIsTreatmentPlansEnabled] = useState(false);
  const [isAppointmentsEnabled, setIsAppointmentsEnabled] = useState(true);
  const [isSuppliesEnabled, setIsSuppliesEnabled] = useState(true);

  const [isDashboardEnabled, setIsDashboardEnabled] = useState(true);
  const [isPatientsEnabled, setIsPatientsEnabled] = useState(true);
  const [isEmployeesEnabled, setIsEmployeesEnabled] = useState(true);
  // const [isServicesEnabled, setIsServicesEnabled] = useState(true);
  // const [isServiceGroupsEnabled, setIsServiceGroupsEnabled] = useState(true);
  // const [isProfessionsEnabled, setIsProfessionsEnabled] = useState(true);
  // const [isProfessionGroupsEnabled, setIsProfessionGroupsEnabled] =
  //   useState(true);
  const [isSettingsEnabled, setIsSettingsEnabled] = useState(true);
  const [isSubscriptionsEnabled, setIsSubscriptionsEnabled] = useState(true);
  const [isInvoicesEnabled, setIsInvoicesEnabled] = useState(true);
  const [isUsersEnabled, setIsUsersEnabled] = useState(true);

  const [
    isServicesAndServicesGroupsEnabled,
    setIsServicesAndServiceGroupsEnabled,
  ] = useState(true);
  const [
    isProfessionsAndProfessionGroupsEnabled,
    setIsProfessionsAndProfessionGroupsEnabled,
  ] = useState(true);

  // REDUX
  const dispatch = useDispatch();

  // ✅ EFFECT TO UPDATE MENU ITEMS BASED ON REAL SUBSCRIPTIONS
  // useEffect(() => {
  //   if (tenant && tenant.subscriptions) {
  //     setIsTreatmentPlansEnabled(
  //       tenant.subscriptions.some(
  //         (sub) => sub.name === "treatmentPlans" && sub.status === "active"
  //       )
  //     );
  //     setIsAppointmentsEnabled(
  //       tenant.subscriptions.some(
  //         (sub) => sub.name === "appointments" && sub.status === "active"
  //       )
  //     );
  //     setIsSuppliesEnabled(
  //       tenant.subscriptions.some(
  //         (sub) => sub.name === "supplies" && sub.status === "active"
  //       )
  //     );
  //   }
  // }, [tenant]);
  useEffect(() => {
    if (
      !tenant ||
      !tenant.slug ||
      !tenant.subscriptions ||
      !userInfo?.tenants?.length
    )
      return;

    const matchedTenant = userInfo.tenants.find((t) => t.slug === tenant.slug);

    const matchedPermissions = matchedTenant?.permissions;

    const checkEnabled = (moduleName, checkSubscription = true) => {
      const hasActiveSubscription = checkSubscription
        ? tenant.subscriptions.some(
            (sub) => sub.name === moduleName && sub.status === "active"
          )
        : true;
      const userHasPermission = matchedPermissions?.[moduleName]?.on === true;
      return hasActiveSubscription && userHasPermission;
    };

    setIsTreatmentPlansEnabled(checkEnabled("treatmentPlans"));
    setIsAppointmentsEnabled(checkEnabled("appointments"));
    setIsSuppliesEnabled(checkEnabled("supplies"));
    setIsDashboardEnabled(checkEnabled("dashboard", false)); // 👈 no subscription check
    setIsPatientsEnabled(checkEnabled("patients", false)); // 👈 no subscription check
    setIsEmployeesEnabled(checkEnabled("employees", false)); // 👈 no subscription check
    // setIsServicesEnabled(checkEnabled("services", false)); // 👈 no subscription check
    // setIsServiceGroupsEnabled(checkEnabled("serviceGroups", false)); // 👈 no subscription check
    // setIsProfessionsEnabled(checkEnabled("professions", false)); // 👈 no subscription check
    // setIsProfessionGroupsEnabled(checkEnabled("professionGroups", false)); // 👈 no subscription check
    setIsSettingsEnabled(checkEnabled("settings", false)); // 👈 no subscription check
    setIsSubscriptionsEnabled(checkEnabled("subscriptions", false)); // 👈 no subscription check
    setIsInvoicesEnabled(checkEnabled("invoices", false)); // 👈 no subscription check
    setIsUsersEnabled(checkEnabled("users", false)); // 👈 no subscription check
    setIsServicesAndServiceGroupsEnabled(
      checkEnabled("servicesAndServicesGroups", false)
    ); // 👈 no subscription check
    setIsProfessionsAndProfessionGroupsEnabled(
      checkEnabled("professionsAndProfessionGroups", false)
    ); // 👈 no subscription chec
    // k
  }, [tenant, userInfo]);

  // console.log("tenant", tenant);
  // console.log("userInfo", userInfo);
  // console.log("slug", slug);

  console.log(isAppointmentsEnabled, "isAppointmentsEnabled");

  // MENU ITEMS

  let menuItems = [
    // {
    //   id: 1,
    //   name: t("menu.dashboard"),
    //   route: `/${slug}/dashboard`,
    //   // icon: "/icons/dashboard.svg",
    //   icon: dashboardIcon,
    //   hasSubMenu: false,
    //   subMenuItems: [],
    //   isDisabled: false,
    // },
    // {
    //   id: 3,
    //   name: t("menu.patients"),
    //   route: `/${slug}/patients`,
    //   icon: "/icons/clients.svg",
    //   hasSubMenu: false,
    //   subMenuItems: [
    //     {
    //       name: t("menu.patientList"),
    //       route: "/patients/list",
    //       isDisabled: false,
    //     },
    //   ],
    //   isDisabled: false,
    // },
  ];

  if (isDashboardEnabled) {
    // console.log("✅ Adding Appointments to Menu");
    menuItems.push({
      id: 1,
      name: t("menu.dashboard"),
      route: `/${slug}/dashboard`,
      icon: dashboardIcon,
      hasSubMenu: false,
      subMenuItems: [],
      //   isDisabled: false,
    });
  }

  if (isPatientsEnabled) {
    // console.log("✅ Adding Appointments to Menu");
    menuItems.push({
      id: 3,
      name: t("menu.patients"),
      route: `/${slug}/patients`,
      icon: "/icons/clients.svg",
      hasSubMenu: false,
      subMenuItems: [
        {
          name: t("menu.patientList"),
          route: "/patients/list",
          isDisabled: false,
        },
      ],
      isDisabled: false,
    });
  }

  if (isAppointmentsEnabled) {
    // console.log("✅ Adding Appointments to Menu");
    menuItems.push({
      id: 2,
      name: t("menu.appointments"),
      route: `/${slug}/appointments`,
      icon: "/icons/appointments.svg",
      hasSubMenu: true,
      subMenuItems: [
        {
          name: t("menu.appointmentCalendar"),
          route: `/${slug}/appointments`,
          isDisabled: false,
        },
        {
          name: t("menu.appointmentList"),
          route: `/${slug}/appointments/list`,
          isDisabled: false,
        },
      ],
      isDisabled: false,
    });
  }

  if (isTreatmentPlansEnabled) {
    // This could also check another state like isTreatmentPlansVisible
    menuItems.push({
      id: 4,
      name: t("menu.treatmentPlans"),
      route: `/${slug}/treatment-plans`,
      icon: "/icons/treatment.svg",
      hasSubMenu: false,
      subMenuItems: [],
      isDisabled: false,
    });
  }

  // if (isAcademyEnabled) {
  //   menuItems.push({
  //     id: 23,
  //     name: t("menu.academy"),
  //     route: "/academy",
  //     icon: "/icons/academy.svg",
  //     hasSubMenu: true,
  //     isDisabled: false,
  //     subMenuItems: [
  //       {
  //         name: t("menu.courses"),
  //         route: "academy/courses",
  //         isDisabled: false,
  //       },
  //       {
  //         name: t("menu.speakers"),
  //         route: "academy/speakers",
  //         isDisabled: false,
  //       },
  //       {
  //         name: t("menu.attendees"),
  //         route: "academy/attendees",
  //         isDisabled: false,
  //       },
  //     ],
  //   });
  // }

  if (isSuppliesEnabled) {
    menuItems.push({
      id: 44,
      name: t("menu.supplies"),
      route: null,
      icon: "/icons/supplies.svg",
      hasSubMenu: true,
      isDisabled: false,
      subMenuItems: [
        {
          name: t("menu.suppliesOrders"),
          route: "/supplies/orders",
          isDisabled: false,
        },
        {
          name: t("menu.suppliesProducts"),
          route: "/supplies/products",
          isDisabled: false,
        },
        {
          name: t("menu.suppliesSuppliers"),
          route: "/supplies/suppliers",
          isDisabled: false,
        },
      ],
    });
  }

  if (isEmployeesEnabled) {
    // This could also check another state like isTreatmentPlansVisible
    menuItems.push({
      id: 6,
      name: t("menu.employees"),
      route: `/${slug}/employees`,
      icon: "/icons/clients.svg",
      hasSubMenu: false,
      subMenuItems: [],
      isDisabled: false,
    });
  }

  const settingsSubMenu = [];

  if (isServicesAndServicesGroupsEnabled) {
    settingsSubMenu.push({
      name: t("menu.serviceList"),
      route: `/${slug}/settings/services`,
      isDisabled: false,
    });
    settingsSubMenu.push({
      name: t("menu.serviceGroupList"),
      route: `/${slug}/settings/service-groups`,
      isDisabled: false,
    });
  }

  if (isProfessionsAndProfessionGroupsEnabled) {
    settingsSubMenu.push({
      name: t("menu.professions"),
      route: `/${slug}/settings/professions`,
      isDisabled: false,
    });
    settingsSubMenu.push({
      name: t("menu.professionGroups"),
      route: `/${slug}/settings/profession-groups`,
      isDisabled: false,
    });
  }

  // if (isServicesEnabled) {
  //   settingsSubMenu.push({
  //     name: t("menu.serviceList"),
  //     route: `/${slug}/settings/services`,
  //     isDisabled: false,
  //   });
  // }
  // if (isServiceGroupsEnabled) {
  //   settingsSubMenu.push({
  //     name: t("menu.serviceGroupList"),
  //     route: `/${slug}/settings/service-groups`,
  //     isDisabled: false,
  //   });
  // }
  // if (isProfessionsEnabled) {
  //   settingsSubMenu.push({
  //     name: t("menu.professions"),
  //     route: `/${slug}/settings/professions`,
  //     isDisabled: false,
  //   });
  // }
  // if (isProfessionGroupsEnabled) {
  //   settingsSubMenu.push({
  //     name: t("menu.professionGroups"),
  //     route: `/${slug}/settings/profession-groups`,
  //     isDisabled: false,
  //   });
  // }

  // Always include clinicSettings if allowed
  settingsSubMenu.unshift({
    name: t("menu.clinicSettings"),
    route: `/${slug}/settings/clinic-settings`,
    // isDisabled: !isSettingsEnabled, // use this to disable if needed
  });

  if (settingsSubMenu.length > 0) {
    menuItems.push({
      id: 88,
      name: t("menu.settings"),
      route: null,
      icon: "/icons/settings.svg",
      hasSubMenu: true,
      isDisabled: false,
      subMenuItems: settingsSubMenu,
    });
  }

  // menuItems.push({
  //   id: 88,
  //   name: t("menu.settings"),
  //   route: null,
  //   icon: "/icons/settings.svg",
  //   hasSubMenu: true,
  //   isDisabled: false,
  //   subMenuItems: [
  //     {
  //       name: t("menu.clinicSettings"),
  //       route: `/${slug}/settings/clinic-settings`,
  //       isDisabled: false,
  //     },
  //     {
  //       name: t("menu.serviceList"),
  //       route: `/${slug}/settings/services`,
  //       isDisabled: false,
  //     },
  //     {
  //       name: t("menu.serviceGroupList"),
  //       route: `/${slug}/settings/service-groups`,
  //       isDisabled: false,
  //     },
  //     {
  //       name: t("menu.professions"),
  //       route: `/${slug}/settings/professions`,
  //       isDisabled: false,
  //     },
  //     {
  //       name: t("menu.professionGroups"),
  //       route: `/${slug}/settings/profession-groups`,
  //       isDisabled: false,
  //     },
  //   ],
  // });

  // Filter out settings and appointments menu if user is not an admin
  // if (!isAdmin) {
  //   menuItems = menuItems.filter(
  //     (menuItem) =>
  //       menuItem.id !== 10 && menuItem.id !== 2 && menuItem.id !== 90
  //   );
  // }

  // LOGS

  // console.log("MenuItems tenantOnboardingInfo", tenantOnboardingInfo);
  // console.log("MenuItems tenant", tenant);
  // console.log("MenuItems isTreatmentPlansEnabled", isTreatmentPlansEnabled);
  // console.log("MenuItems isAcademyEnabled", isAcademyEnabled);

  // console.log("🛠 Final menuItems:", menuItems);
  // console.log(
  //   "🛠 Appointments exists?",
  //   menuItems.some((item) => item.name === t("menu.appointments"))
  // );
  // console.log(
  //   "🛠 Treatment Plans exists?",
  //   menuItems.some((item) => item.name === t("menu.treatmentPlans"))
  // );
  // console.log(
  //   "🛠 Supplies exists?",
  //   menuItems.some((item) => item.name === t("menu.supplies"))
  // );

  return menuItems;
};

export default MenuItems;
